import { Action, createReducer, on } from '@ngrx/store';

import * as MajorActions from './major.actions';
import * as MajorFeatureState from './major.state';
import { FavoriteOccupationsActions } from '../favorite-occupations';

const majorReducer = createReducer(
  MajorFeatureState.initialMajorState,

  on(MajorActions.setMajor, (state, { majorModel }) => {
    return { ...state, majorModel };
  }),

  on(MajorActions.removeMajor, (state) => {
    return MajorFeatureState.majorStateAdapter.removeAll({
      ...state,
      majorModel: null,
    });
  }),

  on(MajorActions.receivedOccupationList, (state, { entities }) => {
    return MajorFeatureState.majorStateAdapter.addMany(entities, { ...state });
  }),

  on(
    FavoriteOccupationsActions.addFavoriteOccupation,
    (state, { onetCode }) => {
      const updateModel = { id: onetCode, changes: { isFavorite: true } };

      return MajorFeatureState.majorStateAdapter.updateOne(updateModel, {
        ...state,
      });
    }
  ),

  on(
    FavoriteOccupationsActions.removeFavoriteOccupation,
    (state, { onetCode }) => {
      const updateModel = { id: onetCode, changes: { isFavorite: false } };

      return MajorFeatureState.majorStateAdapter.updateOne(updateModel, {
        ...state,
      });
    }
  )
);

export function reducer(
  state: MajorFeatureState.MajorState | undefined,
  action: Action
) {
  return majorReducer(state, action);
}
